import { createContext } from "react";
/**
 * A context to provide a single instance of `TrackHandler` and `TrackReceiver` to wherever the context is used.
 * This defaults to both internal objects being undefined.
 */
export var TrackContext = createContext({});
